module.exports = __webpack_public_path__ + "img/image23.39ed3944.webp";